import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';

export class ShareButton {
  constructor(container) {
    this.container = container;
    this.button = this.container.querySelector(s.selectors$z.button);
    this.tooltip = this.container.querySelector(s.selectors$z.tooltip);
    this.transitionSpeed = 200;
    this.hideTransitionTimeout = 0;
    this.init();
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', () => {
        let targetUrl = window.location.href;
        if (this.button.dataset.shareLink) {
          targetUrl = this.button.dataset.shareLink;
        }

        if (!this.tooltip.classList.contains(c.classes$p.visible)) {
          navigator.clipboard.writeText(targetUrl).then(() => {
            this.tooltip.classList.add(c.classes$p.visible);
            setTimeout(() => {
              this.tooltip.classList.add(c.classes$p.hiding);
              this.tooltip.classList.remove(c.classes$p.visible);

              if (this.hideTransitionTimeout) {
                clearTimeout(this.hideTransitionTimeout);
              }

              this.hideTransitionTimeout = setTimeout(() => {
                this.tooltip.classList.remove(c.classes$p.hiding);
              }, this.transitionSpeed);
            }, 1500);
          });
        }
      });
    }
  }
}